(ns measure.report-page.view
  (:require [clojure.string :as str]
            [common.flags :refer [use-flag]]
            [common.widgets.page :as page]
            [linked.core :as l]
            [measure.report-builder.context :as report-builder.ctx]
            [measure.report-builder.core :refer [entity-names]]
            [measure.report-builder.view.core :refer [report-builder]]
            [measure.report-schedule-table.view :as report-schedule-table]
            [measure.report-table.view :as report-table]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(rf/reg-event-fx ::clear-query-params
  (fn [_ _]
    {:router/update-query #(dissoc % :adset-id :channel :new-report)}))

(defn label [entity]
  (str/capitalize (str (get entity-names entity) "s")))

(def report-tabs
  (l/map :reports
         {:label (label :report)
          :view report-table/table}

         :report-schedules
         {:label (label :report-schedule)
          :view report-schedule-table/table}))

(defui report-page-content []
  (let [{:keys [open-report-builder]} (report-builder.ctx/use-report-builder-context)
        query-params (use-subscribe [:router/query-parameters])
        unified-reporting-enabled? (use-flag :unified-reporting)]
    (uix/use-effect
     (fn []
       (let [{:keys [new-report channel adset-id]} query-params]
         (when new-report
           (if unified-reporting-enabled?
             (do (open-report-builder {:entity :report
                                       :mode :create
                                       :initial-value (when (and channel adset-id)
                                                        {:channel channel :adset-ids [adset-id]})})
                 (rf/dispatch-sync [::clear-query-params]))
             (rf/dispatch [:form.report/open {:entity :report}])))))
     [query-params unified-reporting-enabled? open-report-builder])

    ($ page/page
       ($ page/page-header
          {:title "Reporting"
           :tabs report-tabs})
       ($ page/active-tab
          {:tabs report-tabs
           :sx #js {:overflow "hidden"}}))))

(defn report-page []
  ($ report-builder.ctx/provider
     ($ report-page-content)
     ($ report-builder)))
